import styled from 'styled-components';
import { Table as SemanticTable, Icon as SemanticIcon } from 'semantic-ui-react';
import { Text as TextLayoutComponent, Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  overflow: auto;
`;
export const Text = styled(TextLayoutComponent)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 270px;
  gap: 8px;
`;

export const Table = styled(SemanticTable)``;
export const Header = styled(Table.Header)``;
export const HeaderColumn = styled(Table.HeaderCell)`
  min-width: 50px;
`;
export const Column = styled(Table.Cell)`
  min-width: 50px;
  height: 42px;
`;
export const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const Row = styled(Table.Row)``;
export const Body = styled(Table.Body)``;

export const Icon = styled(SemanticIcon)`
  &&& {
    display: inline;
    align-items: center;
    justify-content: center;
    margin: 0;
    margin-left: 6px;
    width: 6px;
    height: 100%;
    color: #6d6de7;
    cursor: pointer;
  }
`;

export const ReprocessButton = styled(ButtonLayoutComponent)`
`;
